(function () {
  const PRINT_W = 28.02;
  const PRINT_H = 43.26;
  const MIN_SHEETS = 10;

  const MATERIALS = {
    paper: { name: 'กระดาษขาว', tiers: [{min:10,max:24,price:40},{min:25,max:49,price:35},{min:50,max:99,price:30},{min:100,max:Infinity,price:25}], whiteInk: false },
    kraft: { name: 'กระดาษคราฟท์', tiers: [{min:10,max:24,price:55},{min:25,max:49,price:45},{min:50,max:99,price:37},{min:100,max:Infinity,price:30}], whiteInk: false },
    'pp-white': { name: 'PP ขาวกันน้ำ', tiers: [{min:10,max:24,price:60},{min:25,max:49,price:50},{min:50,max:99,price:45},{min:100,max:Infinity,price:40}], whiteInk: false },
    'pp-clear': { name: 'PP ใส', tiers: [{min:10,max:24,price:65},{min:25,max:49,price:59},{min:50,max:99,price:53},{min:100,max:Infinity,price:50}], whiteInk: true },
    'pp-gold': { name: 'PP ทอง/เงิน', tiers: [{min:10,max:24,price:90},{min:25,max:49,price:80},{min:50,max:99,price:75},{min:100,max:Infinity,price:70}], whiteInk: true },
    pet: { name: 'PET เงิน', tiers: [{min:10,max:24,price:120},{min:25,max:49,price:110},{min:50,max:99,price:100},{min:100,max:Infinity,price:85}], whiteInk: false },
    hologram: { name: 'โฮโลแกรม', tiers: null, whiteInk: false },
    'security-void': { name: 'Security วอยด์', tiers: [{min:10,max:24,price:200},{min:25,max:49,price:180},{min:50,max:99,price:165},{min:100,max:Infinity,price:150}], whiteInk: false },
    security: { name: 'Security เปลือกไข่', tiers: null, whiteInk: false }
  };

  // ลำดับต้องตรงกับลำดับปุ่มใน HTML (fallback ถ้า data-attribute หาย)
  const MAT_KEYS = ['paper','kraft','pp-white','pp-clear','pp-gold','pet','hologram','security-void','security'];
  const SHAPE_KEYS = ['rect','circle','oval','diecut'];

  let currentMat = 'paper';
  let currentShape = 'rect';

  function baht(n) {
    return '฿' + Number(n || 0).toLocaleString();
  }

  function getPrice(mat, sheets) {
    const m = MATERIALS[mat];
    if (!m || !m.tiers) return null;
    const tier = m.tiers.find(t => sheets >= t.min && sheets <= t.max);
    return tier ? tier.price : null;
  }

  function layoutCount(sw, sh, gapCm) {
    const colsN = Math.floor((PRINT_W + gapCm) / (sw + gapCm));
    const rowsN = Math.floor((PRINT_H + gapCm) / (sh + gapCm));
    const countN = Math.max(0, colsN * rowsN);

    const colsR = Math.floor((PRINT_W + gapCm) / (sh + gapCm));
    const rowsR = Math.floor((PRINT_H + gapCm) / (sw + gapCm));
    const countR = Math.max(0, colsR * rowsR);

    if (countR > countN) return { cols: colsR, rows: rowsR, count: countR, rotated: true };
    return { cols: colsN, rows: rowsN, count: countN, rotated: false };
  }

  function selectMat(btn) {
    document.querySelectorAll('.calc-mat-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');

    const matKey = btn.dataset.mat || MAT_KEYS[Array.from(document.querySelectorAll('.calc-mat-btn')).indexOf(btn)] || 'paper';
    currentMat = MATERIALS[matKey] ? matKey : 'paper';

    const mat = MATERIALS[currentMat];
    const wiLabel = document.getElementById('labelWhiteInk');
    const chkWhiteInk = document.getElementById('chkWhiteInk');

    if (wiLabel && chkWhiteInk) {
      const allowWhiteInk = !!(mat && mat.whiteInk);
      wiLabel.style.opacity = allowWhiteInk ? '1' : '0.4';
      wiLabel.style.pointerEvents = allowWhiteInk ? '' : 'none';
      if (!allowWhiteInk) chkWhiteInk.checked = false;
    }

    calculate();
  }

  function selectShape(btn) {
    document.querySelectorAll('.shape-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');

    const shapeKey = btn.dataset.shape || SHAPE_KEYS[Array.from(document.querySelectorAll('.shape-btn')).indexOf(btn)] || 'rect';
    currentShape = SHAPE_KEYS.includes(shapeKey) ? shapeKey : 'rect';

    const rectInputs = document.getElementById('rectInputs');
    const circleInputs = document.getElementById('circleInputs');

    if (rectInputs && circleInputs) {
      rectInputs.style.display = currentShape === 'circle' ? 'none' : '';
      circleInputs.style.display = currentShape === 'circle' ? '' : 'none';
    }

    calculate();
  }

  function calculate() {
    const gapRaw = parseFloat(document.getElementById('sGap')?.value);
    const gapMm = Number.isFinite(gapRaw) && gapRaw >= 0 ? gapRaw : 3;
    const gapCm = gapMm / 10;

    let sw = 0;
    let sh = 0;

    if (currentShape === 'circle') {
      const d = parseFloat(document.getElementById('sDiam')?.value) || 0;
      sw = d;
      sh = d;
    } else {
      sw = parseFloat(document.getElementById('sW')?.value) || 0;
      sh = parseFloat(document.getElementById('sH')?.value) || 0;
    }

    const qty = parseInt(document.getElementById('sQty')?.value, 10) || 0;

    const rPerSheet = document.getElementById('rPerSheet');
    const rLayout = document.getElementById('rLayout');
    const rSheets = document.getElementById('rSheets');
    const rPricePerSheet = document.getElementById('rPricePerSheet');
    const rTotal = document.getElementById('rTotal');
    const tierBox = document.getElementById('tierBox');

    if (sw <= 0 || sh <= 0 || qty <= 0) {
      if (rPerSheet) rPerSheet.textContent = '–';
      if (rLayout) rLayout.textContent = '';
      if (rSheets) rSheets.textContent = '–';
      if (rPricePerSheet) rPricePerSheet.textContent = '–';
      if (rTotal) rTotal.textContent = '–';
      if (tierBox) tierBox.style.display = 'none';
      clearCanvas();
      return;
    }

    const layout = layoutCount(sw, sh, gapCm);

    if (!layout.count || layout.count <= 0) {
      if (rPerSheet) rPerSheet.textContent = '0';
      if (rLayout) rLayout.textContent = 'ขนาดใหญ่เกินพื้นที่พิมพ์ A3';
      if (rSheets) rSheets.textContent = '–';
      if (rPricePerSheet) rPricePerSheet.textContent = '–';
      if (rTotal) rTotal.textContent = '–';
      if (tierBox) tierBox.style.display = 'none';
      clearCanvas();
      return;
    }

    const effectiveSW = layout.rotated ? sh : sw;
    const effectiveSH = layout.rotated ? sw : sh;

    if (rPerSheet) rPerSheet.textContent = layout.count.toLocaleString();
    if (rLayout) {
      rLayout.textContent = `${layout.cols} คอลัมน์ × ${layout.rows} แถว` + (layout.rotated ? ' (หมุน 90°)' : '');
    }

    const sheetsNeeded = Math.max(MIN_SHEETS, Math.ceil(qty / layout.count));
    if (rSheets) rSheets.textContent = `${sheetsNeeded.toLocaleString()} แผ่น`;

    const mat = MATERIALS[currentMat];
    const chkLam = document.getElementById('chkLaminate')?.checked || false;
    const chkWI = (document.getElementById('chkWhiteInk')?.checked || false) && mat && mat.whiteInk;

    const rowLam = document.getElementById('rowLaminate');
    const rowWI = document.getElementById('rowWhiteInk');
    const lamExtra = document.getElementById('laminateExtra');
    const rLaminateTotal = document.getElementById('rLaminateTotal');

    if (!mat || !mat.tiers) {
      if (rPricePerSheet) rPricePerSheet.textContent = 'ขอใบเสนอราคา';
      if (rTotal) rTotal.textContent = 'ติดต่อสอบถาม';
      if (rowLam) rowLam.style.display = 'none';
      if (rowWI) rowWI.style.display = 'none';
      if (tierBox) tierBox.style.display = 'none';
    } else {
      const pricePerSheet = getPrice(currentMat, sheetsNeeded);
      const baseCost = pricePerSheet * sheetsNeeded;
      const laminateCost = chkLam ? sheetsNeeded * 10 : 0;
      const whiteInkCost = chkWI ? 300 : 0;
      const totalCost = baseCost + laminateCost + whiteInkCost;

      if (rPricePerSheet) rPricePerSheet.textContent = `${baht(pricePerSheet)}/แผ่น`;
      if (rTotal) rTotal.textContent = baht(totalCost);

      if (rowLam) rowLam.style.display = chkLam ? '' : 'none';
      if (rLaminateTotal) rLaminateTotal.textContent = `+${baht(laminateCost)}`;
      if (rowWI) rowWI.style.display = chkWI ? '' : 'none';
      if (lamExtra) lamExtra.textContent = chkLam ? `+${baht(laminateCost)}` : '';

      renderTierTable(sheetsNeeded);
      if (tierBox) tierBox.style.display = '';
    }

    drawCanvas(effectiveSW, effectiveSH, gapCm, layout.cols, layout.rows);
  }

  function renderTierTable(activeSheets) {
    const mat = MATERIALS[currentMat];
    const tierTable = document.getElementById('tierTable');
    if (!mat || !mat.tiers || !tierTable) return;

    const labels = ['10–24 แผ่น', '25–49 แผ่น', '50–99 แผ่น', '100+ แผ่น'];
    let html = `<thead><tr><th>จำนวนแผ่น</th><th>ราคา/แผ่น</th><th>ราคารวมประมาณ</th></tr></thead><tbody>`;

    mat.tiers.forEach((t, i) => {
      const active = activeSheets >= t.min && activeSheets <= t.max;
      const sampleSheets = active ? activeSheets : t.min;

      html += `
        <tr class="${active ? 'active-tier' : ''}">
          <td>${labels[i]}</td>
          <td>${baht(t.price)}</td>
          <td style="color:var(--oc-ink-40)">${baht(sampleSheets * t.price)}${active ? '' : '+'}</td>
        </tr>
      `;
    });

    html += '</tbody>';
    tierTable.innerHTML = html;
  }

  function clearCanvas() {
    const canvas = document.getElementById('layoutCanvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const w = canvas.clientWidth || 360;
    const h = canvas.clientHeight || 500;

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#f3f7fa';
    ctx.fillRect(0, 0, w, h);

    const canvasCount = document.getElementById('canvasCount');
    if (canvasCount) canvasCount.textContent = '';
  }

  function drawCanvas(sw, sh, gapCm, cols, rows) {
    const canvas = document.getElementById('layoutCanvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const CSS_W = 360;
    const CSS_H = 500;

    canvas.width = CSS_W * dpr;
    canvas.height = CSS_H * dpr;
    canvas.style.width = '100%';
    canvas.style.maxWidth = CSS_W + 'px';
    canvas.style.height = 'auto';

    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const BLEED = 2.54;
    const SHEET_W = PRINT_W + BLEED * 2;
    const SHEET_H = PRINT_H + BLEED * 2;

    const MARGIN = 24;
    const RULER_W = 20;

    const drawW = CSS_W - MARGIN * 2 - RULER_W;
    const drawH = CSS_H - MARGIN * 2;

    const scale = Math.min(drawW / SHEET_W, drawH / SHEET_H);
    const sheetPxW = SHEET_W * scale;
    const sheetPxH = SHEET_H * scale;

    const ox = MARGIN + RULER_W + (drawW - sheetPxW) / 2;
    const oy = MARGIN + (drawH - sheetPxH) / 2;
    const bleedPx = BLEED * scale;

    const px0 = ox + bleedPx;
    const py0 = oy + bleedPx;
    const printPxW = PRINT_W * scale;
    const printPxH = PRINT_H * scale;

    ctx.clearRect(0, 0, CSS_W, CSS_H);
    ctx.fillStyle = '#f3f7fa';
    ctx.fillRect(0, 0, CSS_W, CSS_H);

    ctx.shadowColor = 'rgba(0,0,0,0.10)';
    ctx.shadowBlur = 12;
    ctx.fillStyle = '#e8edf2';
    ctx.fillRect(ox, oy, sheetPxW, sheetPxH);
    ctx.shadowBlur = 0;

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(px0, py0, printPxW, printPxH);

    ctx.save();
    ctx.setLineDash([4, 3]);
    ctx.strokeStyle = 'rgba(220,60,60,0.45)';
    ctx.lineWidth = 1;
    ctx.strokeRect(px0, py0, printPxW, printPxH);
    ctx.restore();

    ctx.strokeStyle = '#c5ccd4';
    ctx.strokeRect(ox, oy, sheetPxW, sheetPxH);

    const pxW = sw * scale;
    const pxH = sh * scale;
    const pxGap = gapCm * scale;

    const isDiecut = currentShape === 'diecut';
    const fill = isDiecut ? 'rgba(167,139,250,0.22)' : 'rgba(20,201,223,0.22)';
    const stroke = isDiecut ? '#818CF8' : '#17a9bb';

    let drawn = 0;
    const maxDraw = Math.min(cols * rows, 400);

    for (let r = 0; r < rows && drawn < maxDraw; r++) {
      for (let c = 0; c < cols && drawn < maxDraw; c++) {
        const x = px0 + c * (pxW + pxGap);
        const y = py0 + r * (pxH + pxGap);

        ctx.fillStyle = fill;
        ctx.strokeStyle = stroke;
        ctx.lineWidth = 0.75;
        ctx.beginPath();

        if (currentShape === 'circle') {
          const rad = Math.min(pxW, pxH) / 2;
          ctx.ellipse(x + pxW / 2, y + pxH / 2, rad, rad, 0, 0, Math.PI * 2);
        } else if (currentShape === 'oval') {
          ctx.ellipse(x + pxW / 2, y + pxH / 2, pxW / 2, pxH / 2, 0, 0, Math.PI * 2);
        } else if (currentShape === 'diecut') {
          const cx = x + pxW / 2;
          const cy = y + pxH / 2;
          for (let i = 0; i < 5; i++) {
            const a = -Math.PI / 2 + (i / 5) * Math.PI * 2;
            const px2 = cx + (pxW / 2) * Math.cos(a);
            const py2 = cy + (pxH / 2) * Math.sin(a);
            i === 0 ? ctx.moveTo(px2, py2) : ctx.lineTo(px2, py2);
          }
          ctx.closePath();
        } else {
          const cr = Math.min(2.5, pxW * 0.1, pxH * 0.1);
          if (ctx.roundRect) ctx.roundRect(x, y, pxW, pxH, cr);
          else ctx.rect(x, y, pxW, pxH);
        }

        ctx.fill();
        ctx.stroke();
        drawn++;
      }
    }

    ctx.fillStyle = '#6B7280';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';
    ctx.font = '12px sans-serif';
    ctx.fillText(`${PRINT_W} cm`, px0 + printPxW / 2, py0 - 5);

    ctx.save();
    ctx.translate(ox - 5, py0 + printPxH / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.textAlign = 'center';
    ctx.fillText(`${PRINT_H} cm`, 0, 0);
    ctx.restore();

    ctx.fillStyle = 'rgba(220,60,60,0.55)';
    ctx.textAlign = 'right';
    ctx.textBaseline = 'top';
    ctx.fillText(`bleed ${BLEED} cm`, ox + sheetPxW - 3, oy + sheetPxH + 3);

    const canvasCount = document.getElementById('canvasCount');
    if (canvasCount) canvasCount.textContent = `${cols}×${rows} = ${(cols * rows).toLocaleString()} ดวง`;
  }

  function syncFilterActive(type) {
    const map = [
      'all',
      'paper',
      'kraft',
      'pp-white',
      'pp-clear',
      'pp-gold',
      'pet',
      'security',
      'clear',
      'foil',
      'reflective'
    ];

    document.querySelectorAll('.filter-inner .ftag').forEach((btn, index) => {
      btn.classList.toggle('active', (map[index] || 'all') === type);
    });

    document.querySelectorAll('.material-scroll .mat-chip').forEach((chip, index) => {
      const chipType = chip.dataset.type || map[index] || 'all';
      chip.classList.toggle('active', chipType === type);
    });
  }

  function selectMaterialChip(chip, shouldScroll) {
    const index = Array.from(document.querySelectorAll('.material-scroll .mat-chip')).indexOf(chip);
    const map = [
      'all',
      'paper',
      'kraft',
      'pp-white',
      'pp-clear',
      'pp-gold',
      'pet',
      'clear',
      'security',
      'foil',
      'reflective'
    ];

    const type = chip.dataset.type || map[index] || 'all';
    filterProducts(type);
    syncFilterActive(type);

    if (shouldScroll) {
      const products = document.getElementById('products');
      if (products) {
        const top = products.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }
  }

  function filterProducts(type, clickedBtn) {
    if (clickedBtn) syncFilterActive(type);

    document.querySelectorAll('#productGrid .pcard, #productGrid2 .pcard').forEach(card => {
      card.style.display = (type === 'all' || card.dataset.type === type) ? '' : 'none';
    });
  }

  function scrollToCard(id) {
    const card = document.getElementById(id);
    if (!card) return;

    const toggle = card.querySelector('.price-toggle');
    const body = card.querySelector('.price-body');

    if (toggle && body && !toggle.classList.contains('open')) {
      toggle.classList.add('open');
      body.classList.add('open');
    }

    const top = card.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  window.calculate = calculate;
  window.selectMat = selectMat;
  window.selectShape = selectShape;
  window.filterProducts = filterProducts;
  window.selectMaterialChip = selectMaterialChip;
  window.syncFilterActive = syncFilterActive;
  window.scrollToCard = scrollToCard;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.calc-mat-btn, .shape-btn, .price-toggle, .ftag, .itab, .material-scroll .mat-chip').forEach(btn => {
      btn.setAttribute('type', 'button');
    });


    document.querySelectorAll('.material-scroll .mat-chip').forEach((chip, index) => {
      const map = ['all','paper','kraft','pp-white','pp-clear','pp-gold','pet','clear','security','foil','reflective'];
      chip.dataset.type = chip.dataset.type || map[index] || 'all';
      chip.setAttribute('role', 'button');
      chip.setAttribute('tabindex', '0');
    });

    document.addEventListener('click', function (e) {

      const materialChip = e.target.closest('.material-scroll .mat-chip');
      if (materialChip) {
        e.preventDefault();
        selectMaterialChip(materialChip, true);
        return;
      }

      const matBtn = e.target.closest('.calc-mat-btn');
      if (matBtn) {
        e.preventDefault();
        selectMat(matBtn);
        return;
      }

      const shapeBtn = e.target.closest('.shape-btn');
      if (shapeBtn) {
        e.preventDefault();
        selectShape(shapeBtn);
        return;
      }

      const priceToggle = e.target.closest('.price-toggle');
      if (priceToggle) {
        e.preventDefault();
        const body = priceToggle.nextElementSibling;
        priceToggle.classList.toggle('open');
        if (body) body.classList.toggle('open');
        return;
      }

      const filterBtn = e.target.closest('.filter-inner .ftag');
      if (filterBtn) {
        e.preventDefault();

        const index = Array.from(document.querySelectorAll('.filter-inner .ftag')).indexOf(filterBtn);
        const map = [
          'all',
          'paper',
          'kraft',
          'pp-white',
          'pp-clear',
          'pp-gold',
          'pet',
          'security',
          'clear',
          'foil',
          'reflective'
        ];

        const type = map[index] || 'all';
        filterProducts(type, filterBtn);
        syncFilterActive(type);
        return;
      }

      const tab = e.target.closest('.itab');
      if (tab) {
        e.preventDefault();

        const tabId = tab.dataset.tab;
        const wrap = tab.closest('.inkjet-tabs');
        if (!wrap) return;

        wrap.querySelectorAll('.itab').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        wrap.querySelectorAll('.itab-content').forEach(c => c.classList.remove('active'));
        const target = wrap.querySelector(`.itab-content[data-tab="${tabId}"]`);
        if (target) target.classList.add('active');
      }
    });


    document.addEventListener('keydown', function (e) {
      const materialChip = e.target.closest && e.target.closest('.material-scroll .mat-chip');
      if (!materialChip) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      selectMaterialChip(materialChip, true);
    });

    ['sW', 'sH', 'sDiam', 'sGap', 'sQty', 'chkLaminate', 'chkWhiteInk'].forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', calculate);
      el.addEventListener('change', calculate);
    });

    const selectedMat = document.querySelector('.calc-mat-btn.selected') || document.querySelector('.calc-mat-btn');
    if (selectedMat) selectMat(selectedMat);

    const selectedShape = document.querySelector('.shape-btn.selected') || document.querySelector('.shape-btn');
    if (selectedShape) selectShape(selectedShape);

    syncFilterActive('all');

    const sentinel = document.getElementById('filterbarSentinel');
    const bar = document.getElementById('filterbar');

    if (sentinel && bar && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            bar.classList.add('is-sticky');
          } else {
            bar.classList.remove('is-sticky');
          }
        });
      }, { threshold: 0 });

      io.observe(sentinel);
    }

    calculate();
  });
})();
